import React from "react";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

import { BannerInline } from "../bannerInline/BannerInline";
import { isRoamingLimitReached } from "../../store/devices/logicalDevices";

export const RoamingLimitReachedWarningReadonly = () => {
  const isLimitReached = useSelector(isRoamingLimitReached);

  if (!isLimitReached) return null;

  return (
    <BannerInline
      header={
        <FormattedMessage id="roaming_reached_limit_info_deeplink_dialog_header" />
      }
      message={
        <FormattedMessage id="roaming_reached_limit_info_deeplink_dialog_content" />
      }
      className={"roaming-limit-reached-warning"}
    />
  );
};
